import { Injectable, inject, isDevMode } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';
import { MessageService } from 'primeng/api';
import { LoggerService } from './logger.service';

@Injectable({ providedIn: 'root' })
export class PwaUpdateService {
  private swUpdate = inject(SwUpdate);
  private messageService = inject(MessageService);
  private logger = inject(LoggerService);

  initialize(): void {
    if (!this.swUpdate.isEnabled) {
      if (isDevMode()) {
        this.logger.debug('Service worker is not enabled');
      }
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
      .subscribe(() => {
        this.messageService.add({
          severity: 'info',
          summary: 'Update Available',
          detail: 'A new version is available. Click here to update.',
          sticky: true,
          closable: true,
          key: 'pwa-update',
          data: { action: 'reload' },
        });
      });

    this.swUpdate.unrecoverable.subscribe(() => {
      this.logger.warn('Service worker unrecoverable state — reloading');
      document.location.reload();
    });
  }

  applyUpdate(): void {
    document.location.reload();
  }
}
